import { Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import MolCard from 'components/MolCard';
import { CartMember, SupplierItem } from 'features/shoppingCart/shoppingCartSlice';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(11rem, 1fr))',
      gridAutoRows: 'auto',
      gridGap: theme.spacing(3),
    },
  }),
);

interface Props {
  availability: SupplierItem[];
  selectedSupplier: string | undefined;
  member: CartMember;
  toggleSelection: (supplier: SupplierItem) => void;
}

export default ({ availability, selectedSupplier, member, toggleSelection }: Readonly<Props>) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {availability
        .filter(item => !selectedSupplier || item.supplier === selectedSupplier)
        .map(item => (
          <MolCard
            key={`${item.code}`}
            smiles={item.smiles}
            raised={member.selectedItems.map(item => item.code).includes(item.code)}
            onClick={() => toggleSelection(item)}
          >
            <Typography variant="caption">{item.code}</Typography>
          </MolCard>
        ))}
    </div>
  );
};
